module.exports = __webpack_public_path__ + "img/marker-point-azul.155bbf33.png";